import parseDuration from "../../../../../../sharedComponents/ParseDuration";

export const HOLIDAY_TYPE = "Feiertag";

// Reihenfolge entspricht der Backend-Aufzählung AbsenceType (deutsche Namen).
export const ABSENCE_TYPE_ORDER = [
    "Urlaub",
    "Krankheit",
    "Kindkrank",
    "Weiterbildung",
    "Berufsschule",
    "Universität",
    "Schule",
    "Sonstiges",
    HOLIDAY_TYPE
];

export const ABSENCE_TYPE_COLORS = {
    "Urlaub": "#d7ecff",
    "Krankheit": "#ffd9d9",
    "Kindkrank": "#ffe3c7",
    "Weiterbildung": "#e6dcff",
    "Berufsschule": "#d9f2e0",
    "Universität": "#d9eef2",
    "Schule": "#e8f0d9",
    "Sonstiges": "#ececec",
    [HOLIDAY_TYPE]: "#fff3bf"
};

export function getTypeColor(absenceType) {
    return ABSENCE_TYPE_COLORS[absenceType] || "#ececec";
}

// Liefert alle Arten in fester Reihenfolge; unbekannte Arten aus den Daten werden
// vor dem Feiertag einsortiert, damit neue Backend-Arten nicht unsichtbar bleiben.
export function getAvailableAbsenceTypes(absences) {
    const foundTypes = new Set();
    (absences || []).forEach(employee => {
        (employee.absencePeriods || []).forEach(period => {
            if (period.absenceType) foundTypes.add(period.absenceType);
        });
    });

    const knownTypes = ABSENCE_TYPE_ORDER.filter(type => type !== HOLIDAY_TYPE);
    const unknownTypes = [...foundTypes]
        .filter(type => !ABSENCE_TYPE_ORDER.includes(type))
        .sort((a, b) => a.localeCompare(b, "de"));

    return [...knownTypes, ...unknownTypes, HOLIDAY_TYPE];
}

export function parseIsoDate(dateString) {
    if (!dateString) return null;
    const [year, month, day] = dateString.split("-").map(Number);
    if (!year || !month || !day) return null;
    return new Date(year, month - 1, day);
}

export function toDateKey(date) {
    return date.getFullYear()
        + "-" + String(date.getMonth() + 1).padStart(2, "0")
        + "-" + String(date.getDate()).padStart(2, "0");
}

export function getDaysOfMonth(year, monthIndex) {
    const days = [];
    const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();
    for (let day = 1; day <= daysInMonth; day++) {
        days.push(new Date(year, monthIndex, day));
    }
    return days;
}

export function durationToMinutes(durationString) {
    const parsed = parseDuration(durationString);
    if (!parsed) return 0;
    return parsed.hours * 60 + parsed.minutes;
}

export function formatHoursMinutes(totalMinutes) {
    const sign = totalMinutes < 0 ? "-" : "";
    const absoluteMinutes = Math.abs(totalMinutes);
    return sign
        + String(Math.floor(absoluteMinutes / 60)).padStart(2, "0")
        + ":" + String(absoluteMinutes % 60).padStart(2, "0");
}

function isDayInPeriod(date, year, monthIndex) {
    if (date.getFullYear() !== year) return false;
    if (monthIndex === null || monthIndex === undefined) return true;
    return date.getMonth() === monthIndex;
}

// Flache Liste aller Abwesenheitstage eines Mitarbeiters im Zeitraum.
// monthIndex === null bedeutet "ganzes Jahr".
export function collectAbsenceDaysForEmployee(employee, year, monthIndex, selectedTypes) {
    const days = [];

    (employee.absencePeriods || []).forEach(period => {
        if (selectedTypes.length > 0 && !selectedTypes.includes(period.absenceType)) return;

        (period.absenceDays || []).forEach(absenceDay => {
            const date = parseIsoDate(absenceDay.date);
            if (!date || !isDayInPeriod(date, year, monthIndex)) return;

            days.push({
                date,
                type: period.absenceType,
                paid: period.paid,
                minutes: durationToMinutes(absenceDay.duration)
            });
        });
    });

    return days;
}

// Aktive Mitarbeiter (die API liefert alle aktiven Mitarbeiter) nach Bereich und
// Mitarbeiterfilter einschränken und für die Tabellen sortieren.
export function getFilteredEmployees(absences, selectedArea, selectedEmployeeIds) {
    return (absences || [])
        .filter(employee => {
            if (selectedArea && !selectedArea.assigned_employee_ids.includes(employee.employeeId)) return false;
            if (selectedEmployeeIds.length > 0 && !selectedEmployeeIds.includes(employee.employeeId)) return false;
            return true;
        })
        .map(employee => ({
            ...employee,
            firstName: employee.employeeFirstName,
            lastName: employee.employeeLastName
        }))
        .sort((a, b) => (a.lastName + a.firstName).localeCompare(b.lastName + b.firstName, "de"));
}
